import BaseService from "@/shared/base.service";
import { useAlertStore } from "@/stores/alert.store";
import { PutConnectorIn } from "@/types/request/putConnectorIn";
import { PutConnectorOut } from "@/types/request/putConnectorOut";

import type { ConnectorInResponse } from "@/types/response/connectorIn";
import type { ConnectorOutResponse } from "@/types/response/connectorOut";

export class ConnectorService {
  static async GetAllConnectorsIn(
    page?: number,
    size?: number,
    connector_id?: string
  ): Promise<ConnectorInResponse | null> {
    try {
      const params = {
        //page,
        //size,
        connector_id,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<ConnectorInResponse>(
        `connectors_in_template`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetAllConnectorsIn:", error);
      return null;
    }
  }
  static async GetConnectorInTemplate(
    connector_id?: string
  ): Promise<ConnectorInResponse | null> {
    try {
      const params = {
        connector_id,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<ConnectorInResponse>(
        `connectors_in_template`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetAllConnectorsIn:", error);
      return null;
    }
  }

  static async GetAllConnectorsOut(
    page?: number,
    size?: number,
    connector_id?: string
  ): Promise<ConnectorOutResponse | null> {
    try {
      const params = {
        //page,
        //size,
        connector_id,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<ConnectorOutResponse>(
        `connectors_out_template`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetAllConnectorsOut:", error);
      return null;
    }
  }

  static async CreateConnectorIn(payload: object): Promise<any | null> {
    try  {

      const response = await BaseService.post<any>(
        "connector_in",
        payload
      );

      if (response) {
        useAlertStore().show("success", "Conector vinculado com sucesso!");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in CreateConnectorIn:", error);
      return null;
    }
  }

  static async PutConnectorIn(payload: PutConnectorIn): Promise<any | null> {
    try  {

      const response = await BaseService.put<any>(
        "connector_in",
        payload
      );

      if (response) {
        useAlertStore().show("success", "Conector editado com sucesso!");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in PutConnectorIn:", error);
      return null;
    }
  }

  static async CreateConnectorOut(payload: object): Promise<any | null> {
    try  {

      const response = await BaseService.post<any>(
        "connector_out",
        payload
      );

      if (response) {
        useAlertStore().show("success", "Conector vinculado com sucesso!");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in CreateConnectorOut:", error);
      return null;
    }
  }

  static async PutConnectorOut(payload: PutConnectorOut): Promise<any | null> {
    try  {

      const response = await BaseService.put<any>(
        "connector_out",
        payload
      );

      if (response) {
        useAlertStore().show("success", "Conector editado com sucesso!");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in PutConnectorOut:", error);
      return null;
    }
  }

  static async GetClientConnectorsIn(
    page?: number,
    size?: number
  ): Promise<ConnectorInResponse | null> {
    try {
      const params = {
        page,
        size,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<ConnectorInResponse>(
        `connector_in`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetClientConnectorsIn:", error);
      return null;
    }
  }  
  
  static async GetClientConnectorsOut(
    page?: number,
    size?: number
  ): Promise<ConnectorOutResponse | null> {
    try {
      const params = {
        page,
        size,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<ConnectorOutResponse>(
        `connector_out`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetClientConnectorsOut:", error);
      return null;
    }
  }

  static async DeleteClientConnectorIn(connector_id: string): Promise<any | null> {
    try {
      const response = await BaseService.delete<ConnectorOutResponse>(
        `connector_in?connector_id=${connector_id}`,
      );

      if (response) {
        useAlertStore().show("warning", "Conector removido com sucesso.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in DeleteClientConnectorIn:", error);
      return null;
    }
  }

  static async IsConnectorAuthenticated(connector_id: string): Promise<any | null> {
    try {
      const response = await BaseService.get<ConnectorOutResponse>(
        `auth_verification?connector_id=${connector_id}`,
      );

      if (response) {
        useAlertStore().show("warning", "Verificando status de autenticação.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in IsConnectorAuthenticated:", error);
      return null;
    }
  }

  /**
   * Inicia o login do conector no Azure. Devolve o codigo que o usuario digita na
   * pagina da Microsoft — a senha nunca passa pelo Bindfy.
   */
  static async StartAzureDeviceCode(connector_id: string): Promise<any | null> {
    try {
      const response = await BaseService.post<any>(
        "connector_in/azure_device_code",
        { connector_id }
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in StartAzureDeviceCode:", error);
      return null;
    }
  }

  /**
   * Pergunta se o login ja foi concluido. Retorna status: pendente | conectado |
   * expirado | recusado. Chamada em intervalos pela UI enquanto estiver pendente.
   */
  static async CheckAzureDeviceCode(connector_id: string): Promise<any | null> {
    try {
      const response = await BaseService.get<any>(
        `connector_in/azure_device_code?connector_id=${connector_id}`
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in CheckAzureDeviceCode:", error);
      return null;
    }
  }

  static async DeleteClientConnectorOut(connector_id: string): Promise<any | null> {
    try {
      const response = await BaseService.delete<ConnectorOutResponse>(
        `connector_out?connector_id=${connector_id}`,
      );

      if (response) {
        useAlertStore().show("warning", "Conector removido com sucesso.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in DeleteClientConnectorOut:", error);
      return null;
    }
  }
}
